import { render, staticRenderFns } from "./WorkflowInlineBox.vue?vue&type=template&id=03b083f1&scoped=true&"
import script from "./WorkflowInlineBox.vue?vue&type=script&lang=js&"
export * from "./WorkflowInlineBox.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowInlineBox.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WorkflowInlineBox.vue?vue&type=style&index=1&id=03b083f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b083f1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VRow})
